import { render, staticRenderFns } from "./CardNewsCms.vue?vue&type=template&id=40390dc8"
import script from "./CardNewsCms.vue?vue&type=script&lang=js"
export * from "./CardNewsCms.vue?vue&type=script&lang=js"
import style0 from "./CardNewsCms.vue?vue&type=style&index=0&id=40390dc8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports